/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AIImproveWriting({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.254 6.732a.106.106 0 0 1 .2 0c.192.549.311.886.505 1.176.173.257.387.483.634.669.28.21.61.346 1.147.567a.115.115 0 0 1 0 .213c-.537.222-.868.358-1.147.568a2.75 2.75 0 0 0-.634.668c-.194.29-.313.628-.505 1.176a.106.106 0 0 1-.2 0c-.193-.548-.311-.886-.506-1.176a2.75 2.75 0 0 0-.634-.668c-.279-.21-.61-.346-1.147-.568a.115.115 0 0 1 0-.213c.537-.221.868-.358 1.147-.567.248-.186.462-.412.634-.669.195-.29.313-.627.506-1.176ZM9.666 1.095a.142.142 0 0 1 .27 0c.258.737.418 1.19.679 1.58.231.346.52.65.851.899.376.282.82.465 1.543.763a.155.155 0 0 1 0 .286c-.723.298-1.167.481-1.543.763-.332.25-.62.553-.851.898-.261.39-.42.844-.68 1.58a.142.142 0 0 1-.268 0c-.26-.736-.419-1.19-.68-1.58a3.694 3.694 0 0 0-.852-.898c-.375-.282-.82-.465-1.542-.763a.155.155 0 0 1 0-.286c.722-.298 1.167-.481 1.542-.763.333-.25.62-.553.852-.898.261-.39.42-.844.68-1.58Z" /><path stroke="currentColor" strokeDasharray="2 3" strokeLinecap="round" strokeWidth={1.2} d="M1.125 14.888h13.75" /></svg>;
}
;